import { admins } from '@/ts/router/admin';
import { profile } from '@/ts/router/profile';
import { statics } from '@/ts/router/statics';
import { support } from '@/ts/router/support';

import { createRouter, createWebHistory } from 'vue-router';
const routes = [
  
  // home
  {path: '/', name: 'home', component: () => import('@/page/index.vue')},  
  
  // public
  {path: '/business',     name: 'business',     component: () => import('@/page/business/index.vue')},
  {path: '/gigs',         name: 'gigs',         component: () => import('@/page/gigs/index.vue')},
  {path: '/jobs',         name: 'jobs',         component: () => import('@/page/jobs/index.vue')},
  {path: '/marketplace',  name: 'marketplace',  component: () => import('@/page/marketplace/index.vue')},
  {path: '/people',       name: 'people',       component: () => import('@/page/people/index.vue')},
  {path: '/places',       name: 'places',       component: () => import('@/page/places/index.vue')},
  {path: '/playlists',    name: 'playlists',    component: () => import('@/page/playlists/index.vue')},
  {path: '/promotion',    name: 'promotion',    component: () => import('@/page/promotion/index.vue')},
  {path: '/remix',        name: 'remix',        component: () => import('@/page/remix/index.vue')},
  {path: '/samples',      name: 'samples',      component: () => import('@/page/samples/index.vue')},
  {path: '/songs',        name: 'songs',        component: () => import('@/page/songs/index.vue')},
  {path: '/video',        name: 'video',        component: () => import('@/page/video/index.vue')},
  
  // profile
  ...profile,

  // docs
  ...statics,
  
  // admins
  ...admins,

  //support
  ...support,


  
  // user pages
  // {path: '/:login', name: 'profile/public', beforeEnter: [isImages], component: () => import('@/page/profile/public/index.vue')},
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {return { top: 0 }},
  linkExactActiveClass: "active",
  routes
})

// function isImages(to: any, from: any, next: any) {
//   if (to.startsWith('images/')){
//     next()
//   } else{
//     next()
//   }
// }


function isImages(to: any, from: any, next: any) {
  console.log('image router', to)
  // to.path - это строка типа "/images/some/path"
  if (to.path.startsWith('/images')) {
    next() // Оставляем на /images/...
  } else {
    // Получаем username из пути (убираем первый слеш)
    const username = to.path.substring(1).split('/')[0]
    if (username && username !== '') {
      next(`/${username}`) // Редирект на /username
    } else {
      next() // Или next('/') на главную
    }
  }
}

export default router
